import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { sunValleyConfig } from "./data";

export default function SunValleyPage() {
  return <CityPageTemplate config={sunValleyConfig} />;
}